import React from 'react';
import cn from 'classnames';
import LoaderDs from '@wix/da-ds/pkg/Loader';

import s from './Loader.scss';

export interface Props {
  type: 'drawer-suspense' | 'drawer' | 'feed';
}

const Loader: React.FC<Props> = ({ type }) => {
  return (
    <div
      className={cn(
        s['root'],
        type === 'drawer-suspense' && s['drawer-suspense'],
        type === 'drawer' && s['drawer'],
        type === 'feed' && s['feed']
      )}
    >
      <LoaderDs size="big" className={s['loader']} />
    </div>
  );
};
Loader.displayName = 'Loader';

export default Loader;
